export const getInitials = (name) => {
  return name
    ? Array.prototype.map
        .call(name.split(" "), function (x) {
          return x.substring(0, 1).toUpperCase();
        })
        .join("")
    : "";
};
